import { CloseCircleOutlined } from '@ant-design/icons';
import { Button, Space } from 'antd';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import { type CompareCalculator } from './Calculator';
import StaticField from './StaticField';
import { GridBox } from './ui';

const comparisonConfig = [
    {
        editable: true,
        size: 1,
        key: 'carModel',
    },
    {
        editable: true,
        size: 1,
        key: 'startingPrice',
    },
    {
        editable: true,
        size: 1,
        key: 'coe',
    },
    {
        editable: false,
        size: 1,
        key: 'totalPrice',
    },
    {
        editable: true,
        size: 1,
        key: 'financialInstitution',
    },
    {
        editable: true,
        size: 1,
        key: 'financialProduct',
    },
    {
        editable: true,
        size: 1,
        key: 'interestRate',
    },
    {
        editable: true,
        size: 1,
        key: 'downPayment',
    },
    {
        editable: true,
        size: 1,
        key: 'tenure',
    },
    {
        editable: true,
        size: 1,
        key: 'loanAmount',
    },
    {
        editable: false,
        size: 1,
        key: 'monthlyPayment',
    },
    {
        editable: false,
        size: 1,
        key: 'promoCode',
    },
];

const Container = styled.div`
    display: flex;
    flex-direction: column;
`;

const Grid = styled.div`
    display: Grid;
    grid-row-gap: 5px;
`;

const Next = styled.div`
    margin-top: 20px;
`;

const CarImageContainer = styled.div`
    position: relative;
    margin-left: 5px;
    max-width: 240px;
    max-height: 120px;
    .ant-btn {
        position: absolute;
        outline: none;
        border: none;
        background-color: transparent;
        padding: 0px;
    }
`;

const CarImage = styled.img`
    width: 100%;
    max-width: 240px;
    max-height: 120px;
    margin: 10px 0px;
`;

interface ComparisonCalculatorProps extends CompareCalculator {
    remove: (id: number) => void;
}

const ComparisonCalculator = ({ id, dataSource, remove }: ComparisonCalculatorProps) => {
    const { t } = useTranslation('calculation');

    const calculatorFields = useMemo(
        () =>
            comparisonConfig.map(obj => (
                <StaticField label={t(`calculation:labels.${obj.key}`)} value={dataSource[obj.key]} {...obj} />
            )),
        [dataSource, t]
    );

    return (
        <Container>
            <Grid>
                <CarImageContainer>
                    <Button icon={<CloseCircleOutlined />} onClick={() => remove(id)} size="large" />
                    <CarImage alt="icon" src={dataSource.imgSrc} />
                </CarImageContainer>
                <GridBox size={1}>{calculatorFields}</GridBox>
                <Space size="large" />
                <Next>
                    <Button size="large" type="primary" block>
                        {t('calculation:actions.next')}
                    </Button>
                </Next>
            </Grid>
        </Container>
    );
};

export default ComparisonCalculator;
